import { renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("li", {
    class: _normalizeClass({'--active': _ctx.isActive}),
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openSubmenu && _ctx.openSubmenu(...args)))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createVNode(_Transition, { name: "transition-fade-down" }, {
      default: _withCtx(() => [
        (_ctx.isActive)
          ? (_openBlock(), _createElementBlock("ul", {
              key: 0,
              class: "oxd-dropdown-menu",
              role: "menu",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeSubMenu && _ctx.closeSubMenu(...args)), ["stop"]))
            }, [
              _renderSlot(_ctx.$slots, "content", {}, undefined, true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 2)), [
    [_directive_click_outside, _ctx.closeSubMenu]
  ])
}